import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'showMinimum'
})
export class ShowMinimumPipe implements PipeTransform {

transform(value: number, min: number): number {
    return Math.min(value, min);
  }


}
